import styled, { css } from "styled-components";
import { rgba } from "polished";
import { color, typeStyle, units, variant } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
export const Tab = styled.span `
  flex-grow: ${({ flexGrow }) => flexGrow};
`;
export const TabInner = styled(NakedButton) `
  --Tab-text-color: ${color("typeBody")};
  --Tab-pressed-text-color: ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand" ? color("typeBody") : color("base", { palette: "structural" })};
  --Tab-active-text-color: ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand" ? color("inverse") : color("typeBody")};
  --Tab-disabled-text-color: ${(props) => props.activeColorScheme === "alchemyBrand"
    ? rgba(color("inverse")(props), 0.3)
    : color("highlight", {
        palette: "interactiveNavigational"
    })};

  --Tab-marker-color: transparent;
  --Tab-hovered-marker-color: ${(props) => props.activeColorScheme === "alchemyBrand"
    ? // TODO: update to only use Alchemy palette or create component-specific token
        "#DDE1E5"
    : color("highlight")};
  --Tab-active-marker-color: ${(props) => props.activeColorScheme === "alchemyBrand" ? color("inverse") : color("base")};
  --Tab-active-disabled-marker-color: ${(props) => props.activeColorScheme === "alchemyBrand"
    ? rgba(color("inverse")(props), 0.3)
    : color("highlight", {
        palette: "interactiveNavigational"
    })};

  position: relative;
  padding: ${units(1)};
  margin: 0;
  text-decoration: none;
  width: 100%;
  ${typeStyle("labelM")};
  user-select: none;

  color: var(--Tab-text-color);

  display: flex;
  align-items: center;
  ${variant("layout", {
    distributed: "justify-content: center;",
    distributedRight: "justify-content: flex-end;",
    distributedLeft: "justify-content: flex-start;",
    left: "justify-content: flex-start;",
    center: "justify-content: center;",
    right: "justify-content: flex-end;"
})};

  ${(props) => css `
    svg {
      color: ${props.activeColorScheme === "alchemyBrand"
    ? rgba(color("inverse")(props), 0.6)
    : color("base", { palette: "structural" })};
    }
  `}

  svg + span {
    margin-top: ${units(1)};
  }

  :visited {
    color: ${color("typeBody")};
  }

  /* tab underline */
  :before,
  :after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    height: 2px;
    right: 0;
    opacity: 0;
    width: 0;
    transform: scaleX(0);
  }

  :before {
    background: var(--Tab-marker-color);
  }

  &:hover:before,
  :after {
    width: auto;
    opacity: 1;
    transform: scaleX(1);
  }

  // (DES-3228) prevent focus ring from being affected by pseudo element
  @media not all and (prefers-reduced-motion) {
    :not(:focus-visible):before {
      transition:
        transform 0.6s ease-in-out 0s,
        background-color 0.6s ease-in-out 0s;

      @media (forced-colors) {
        // (prefers-reduced-motion: no-preference) and (forced-colors: none) doesn't work in Safari for some reason
        transition: transform 0.6s ease-in-out 0s;
      }
    }
  }

  &:hover {
    --Tab-marker-color: var(--Tab-hovered-marker-color);

    @media (forced-colors) {
      --Tab-marker-color: ButtonText;
    }
  }

  :active:not([aria-disabled="true"]) {
    opacity: 0.85;
    color: var(--Tab-pressed-text-color);

    svg {
      color: var(--Tab-pressed-text-color);
    }
  }

  ${(props) => props.isActive &&
    css `
      color: var(--Tab-active-text-color);
      font-weight: bold;

      :active:not([aria-disabled="true"]) {
        opacity: 1;
        color: ${props.activeColorScheme === "alchemyBrand" ? color("inverse") : color("base")};
      }

      svg {
        color: ${props.activeColorScheme === "alchemyBrand" ? color("inverse") : color("base")};
      }

      :visited {
        color: ${props.activeColorScheme === "alchemyBrand" ? color("inverse") : color("base")};
      }

      :before {
        width: auto;
        opacity: 1;
        transform: scaleX(1);
      }

      &,
      &:hover {
        --Tab-marker-color: var(--Tab-active-marker-color);

        @media (forced-colors) {
          color: ButtonText;
          --Tab-marker-color: ButtonText;
        }
      }
    `}

  ${({ "aria-disabled": disabled }) => disabled &&
    disabled !== "false" &&
    css `
      color: var(--Tab-disabled-text-color);
      cursor: default;
      pointer-events: none;

      &,
      &:hover {
        // Should not get shown anyway unless isActive is true
        --Tab-marker-color: var(--Tab-active-disabled-marker-color);

        @media (forced-colors) {
          color: GrayText;
          --Tab-marker-color: GrayText;
        }
      }
    `};
`;
export const TabContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
